import {
    assetsFromFEs,
    debtsFromFEs,
    useFinancialEntitiesContext,
} from '../financialEntities';
import { orderAccountsByBalancePerInstitution } from './orderAccountsByBalanceByInstitution';

export const useMyAccounts = () => {
    const { fes } = useFinancialEntitiesContext();
    if (!fes.unfilteredData?.financialEntities) return;

    const myAssets = assetsFromFEs(fes.unfilteredData.financialEntities).filter(
        (fe) => fe.isMine
    );
    const myDebts = debtsFromFEs(fes.unfilteredData.financialEntities).filter(
        (fe) => fe.isMine
    );

    return [
        ...orderAccountsByBalancePerInstitution(myAssets, 'asset'),
        ...orderAccountsByBalancePerInstitution(myDebts, 'debt'),
    ];
};
